// Third Party Imports
import React from 'react';

// HA Artifactory Imports
import FormSelect from '@homeaway/react-form-select';
import {FormInput} from '@homeaway/react-form-components';

// Relative Imports
import ContinueButtonHolder from '../ButtonHolder/ContinueButtonHolder';
import {getSelectOptions} from '../utils/addressUtil';
import {processTranslation} from '../utils/commonUtil';
import {RegistrationNumber, VatChoice} from '../utils/vatUtil';
import AlertBox from '../Alert/Alert';
import './CompanyLocation.less';

class CompanyLocation extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.triggerEdapPageViewAction();
    }

    getBusinessTypeField = () => {
        const {
            translations,
            businessType,
            businessTypeError,
            handleBusinessTypeChange,
            handleBusinessTypeOnBlur,
            companyName,
            businessTypes
        } = this.props;

        const businessTypeHead = processTranslation(translations['ipmob.company_location.sub_heading_4'], [companyName]);
        const businessTypeList = getSelectOptions({
            ...businessTypes,
            'OTHER': translations['ipmob.company_location.business_type.other']
        });

        return (<div>
            <div className="wrapper">
                <div className="content-col-text sub-head">
                    <h3>{businessTypeHead}</h3>
                </div>
            </div>
            <div className="wrapper">
                <div className="content-col">
                    <FormSelect
                        id="businessType"
                        name="Business type selected"
                        items={businessTypeList}
                        label={translations['ipmob.company_location.label']}
                        value={businessType}
                        onChange={handleBusinessTypeChange}
                        errorMsg={translations[businessTypeError]}
                        onBlur={handleBusinessTypeOnBlur}
                    />
                </div>
            </div>
        </div>);
    };

    render() {
        const {
            translations,
            countryList,

            companyCountryCode,
            handleCompanyLocationChange,
            companyCountryCodeError,
            handleCompanyLocationOnBlur,

            firstName,
            companyName,
            companyNameError,
            handleCompanyNameChange,
            handleCompanyNameOnBlur,

            serviceError,
            handleAlertDismiss,
            enableContinueButton,
            handleFormSubmit,
            handleBackButtonClick,

            showVatChoice,
            showRegistrationNumberChoice,
            showBusinessType,
            triggerEdapEventOnFocus,
            redirectFlag
        } = this.props;

        const countries = (countryList) ? getSelectOptions(countryList) : [];
        const pageTitle = processTranslation(translations['ipmob.company_location.heading_1'], [firstName || '']);
        const companyLocHead = processTranslation(translations['ipmob.company_location.sub_heading_2'], [companyName || '']);
        return (
            <div id="companyInfo" className="company-location">
                <div className="company-location-container">
                    {
                        (serviceError)
                            ? <div className="alert-panel">
                                <AlertBox
                                    messageKey={serviceError}
                                    translations={translations}
                                    handleAlertDismiss={handleAlertDismiss}
                                    size={'sm'}
                                />
                            </div>
                            : null
                    }
                    <div className="wrapper">
                        <div className="content-col-text panel-head">
                            <h1 className="head">{pageTitle}</h1>
                        </div>
                    </div>
                    <form role="form" onSubmit={handleFormSubmit}>
                        <div className="input-container" aria-label="Big form">
                            <div className="wrapper">
                                <div className="content-col-text sub-head">
                                    <h3>{translations['ipmob.company_location.sub_heading_1']}</h3>
                                </div>
                            </div>
                            <div className="wrapper">
                                <div className="content-col">
                                    <FormInput
                                        id="companyName"
                                        type="text"
                                        name="Company name"
                                        label={translations['ipmob.create_account.label_2']}
                                        value={companyName}
                                        errorMsg={translations[companyNameError]}
                                        onChange={handleCompanyNameChange}
                                        maxLength="64"
                                        onBlur={handleCompanyNameOnBlur}
                                        onFocus={triggerEdapEventOnFocus}
                                    />
                                </div>
                            </div>
                        </div>
                        {(companyName.trim())
                            ? <div>
                                <div className="wrapper">
                                    <div className="content-col-text sub-head">
                                        <h3>{companyLocHead}</h3>
                                    </div>
                                </div>
                                <div className="wrapper">
                                    <div className="content-col">
                                        <FormSelect
                                            id="companyLocation"
                                            name="Country selected"
                                            items={countries}
                                            label={translations['ipmob.mailing_address.label_1']}
                                            value={companyCountryCode}
                                            onChange={handleCompanyLocationChange}
                                            errorMsg={translations[companyCountryCodeError]}
                                            onBlur={handleCompanyLocationOnBlur}
                                        />
                                    </div>
                                </div>
                                {(companyCountryCode.trim())
                                    ? <div>
                                        {(showBusinessType) ? this.getBusinessTypeField() : null}
                                        {(showVatChoice) ? <VatChoice {...this.props} /> : null}
                                        {(showRegistrationNumberChoice) ? <RegistrationNumber {...this.props} /> : null}
                                    </div>
                                    : null
                                }
                            </div>
                            : null
                        }
                        <ContinueButtonHolder
                            enableContinueButton={enableContinueButton}
                            handleContinueButtonClick={handleFormSubmit}
                            translations={translations}
                            enableBackButton={!redirectFlag}
                            handleBackButtonClick={handleBackButtonClick}
                            continueButtonId={'companyLocationContinueBtn'}
                        />
                    </form>
                </div>
            </div>
        );
    }
}

export default CompanyLocation;
